<script lang="ts" setup>
const emits = defineEmits(["click"]);

const props = defineProps({
  type: {
    type: String,
  },
  interactive: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <component
    v-if="type === 'contact-add'"
    :is="interactive ? 'button' : 'span'"
    :type="interactive ? 'button' : undefined"
    class="dropdown_button green"
    :aria-label="$t('documentHistory.label.contact-add')"
    @click="emits('click')"
  >
    <span class="material-symbols-outlined" aria-hidden="true">
      person_add
    </span>
  </component>

  <component
    v-else-if="type === 'contact'"
    :is="interactive ? 'button' : 'span'"
    :type="interactive ? 'button' : undefined"
    class="dropdown_button green"
    @click="emits('click')"
  >
    <span class="text">
      <slot></slot>
    </span>
  </component>

  <component
    v-else-if="type === 'presentation'"
    :is="interactive ? 'button' : 'span'"
    :type="interactive ? 'button' : undefined"
    class="dropdown_button green"
    @click="emits('click', 'presentation')"
  >
    <span class="material-symbols-outlined" aria-hidden="true"> live_tv </span>
    <span class="text">
      {{ $t("documentHistory.label.presentation.title") }}
    </span>
    <slot name="right"></slot>
  </component>

  <component
    v-else-if="type === 'self-study'"
    :is="interactive ? 'button' : 'span'"
    :type="interactive ? 'button' : undefined"
    class="dropdown_button blue"
    @click="emits('click', 'self-study')"
  >
    <span class="material-symbols-outlined" aria-hidden="true">
      psychology
    </span>
    <span class="text">
      {{ $t("documentHistory.label.self-study.title") }}
    </span>
    <slot name="right"></slot>
  </component>

  <component
    v-else
    :is="interactive ? 'button' : 'span'"
    :type="interactive ? 'button' : undefined"
    class="dropdown_button grey"
  >
    <span class="material-symbols-outlined" aria-hidden="true">
      question_mark
    </span>
    <span class="text">
      <span>
        {{ $t("documentHistory.label.default.title") }}
      </span>
      <span class="small_text">
        {{ $t("documentHistory.label.default.select") }}
      </span>
    </span>
    <slot name="right"></slot>
  </component>
</template>

<style scoped>
.dropdown_button {
  display: flex;
  align-items: center;
  font: inherit;
  padding: 0 1em;
  border-radius: 8px;
  font-size: 14px;
  height: 45px;
  box-sizing: border-box;
  border: 0;
  appearance: none;
  margin: 0;
  text-align: left;
}

.dropdown_button:hover {
  cursor: pointer;
}

.dropdown_button.grey {
  background-color: var(--classic-surface-raised, #ececec);
  color: var(--classic-text-muted, #737373);
}

.dropdown_button.blue {
  background: var(--classic-accent-soft, #d6fafb);
  color: var(--classic-text, #363636);
}

.dropdown_button.green {
  background: var(--classic-success-surface, #c5e9d0);
  color: var(--classic-text, #363636);
}

.dropdown_button .material-symbols-outlined {
  font-size: 1.2em;
}

.text {
  margin-left: 0.3em;
  margin-right: 0.3em;
  font-weight: 500;
}

.text span {
  display: block;
}

.small_text {
  font-size: 0.85em;
  font-weight: 400;
}
</style>
